import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './TermsAcceptanceModal.css';

const TermsAcceptanceModal = ({ isOpen, onAccept, onDecline }) => {
  const [termsAccepted, setTermsAccepted] = useState(false);

  const handleAccept = () => {
    if (termsAccepted) {
      onAccept();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="terms-modal-overlay">
      <div className="terms-modal">
        <div className="terms-modal-header">
          <h3>Terms of Service & Privacy Policy</h3>
        </div>
        
        <div className="terms-modal-content">
          <p>
            Before using our property analysis tool, please review and accept our Terms of Service and Privacy Policy.
          </p>
          
          <div className="disclaimer-box">
            <p>
              <strong>⚠️ Important:</strong> Analysis provided is for informational purposes only and does not constitute financial, investment, or real estate advice. Please consult with qualified professionals before making investment decisions.
            </p>
          </div>
          
          <div className="terms-checkbox-container">
            <label className="terms-checkbox">
              <input
                type="checkbox"
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
              />
              <span className="terms-text">
                I have read and agree to the <Link to="/terms" target="_blank">Terms of Service</Link> and <Link to="/privacy" target="_blank">Privacy Policy</Link>
              </span>
            </label>
          </div>
        </div>
        
        <div className="terms-modal-actions">
          <button 
            onClick={onDecline}
            className="btn-secondary"
          >
            Decline
          </button>
          <button 
            onClick={handleAccept}
            className="btn-primary"
            disabled={!termsAccepted}
          >
            Accept & Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAcceptanceModal;